/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { GetProjectProgressesQuery } from '../../models/get-project-progresses-query';
import { GetProjectProgressQueryResult } from '../../models/get-project-progress-query-result';

export interface ApiProjectProgressGetProjectProgressesPost$Plain$Params {
      body?: GetProjectProgressesQuery
}

export function apiProjectProgressGetProjectProgressesPost$Plain(http: HttpClient, rootUrl: string, params?: ApiProjectProgressGetProjectProgressesPost$Plain$Params, context?: HttpContext): Observable<StrictHttpResponse<GetProjectProgressQueryResult>> {
  const rb = new RequestBuilder(rootUrl, apiProjectProgressGetProjectProgressesPost$Plain.PATH, 'post');
  if (params) {
    rb.body(params.body, 'application/*+json');
  }

  return http.request(
    rb.build({ responseType: 'text', accept: 'text/plain', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<GetProjectProgressQueryResult>;
    })
  );
}

apiProjectProgressGetProjectProgressesPost$Plain.PATH = '/api/ProjectProgress/GetProjectProgresses';
